import React, { useEffect, useRef, useState } from 'react';
import '../../assets/css/home.css';
import '../../assets/css/blank-project-list.css';
import starSvg from '../../assets/img/awesome-star-dark.svg';
import starOpSvg from '../../assets/img/awesome-star-light.svg';
import notificationIcon from '../../assets/img/notification.svg';
import bellIcon from '../../assets/img/bell.svg';
import featherMenu from '../../assets/img/feather-menu.svg';
import { Dropdown, ProgressBar } from 'react-bootstrap';
import Header from '../../components/Header';
import calenderIcon from 'assets/img/calenderIcon.svg';
import akarFile from '../../assets/img/akar-file.svg';
import searchIcon from '../../assets/img/search.svg';
import rightArrowBlue from '../../assets/img/Icon-right-blue.svg';
import listIcon from '../../assets/img/list.svg';
import gridIcon from '../../assets/img/grid.svg';
import listWhiteIcon from '../../assets/img/listwhite.svg';
import gridWhiteIcon from '../../assets/img/gridwhite.svg';
import chatBoxes from '../../assets/img/chatboxes.svg';
import { useAuth } from '../../contexts/AuthContext';
import ActionMenu from '../../components/ActionMenu';
import SidebarModal from '../../components/SidebarModal';
import KanbanIcon from 'assets/img/kanban.svg';
import Joyride from 'react-joyride';
import akarFile2 from '../../assets/img/akarFile2.svg';

import calenderIcon2 from '../../assets/img/calendar-date.svg';
import khanbanIcon2 from '../../assets/img/khanban-icon.svg';
import msgIcon from '../../assets/img/msg-icon.svg';
import bellIcon2 from '../../assets/img/bell-01.svg';
import rightArrowdown from 'assets/img/right-arrow-down.svg';
import Tippy from '@tippyjs/react';

import {
  clearLocalStorage,
  formatDate,
  formFields,
  getCookies,
  getDaysUntilMidnight,
  getformattedPhoneNumber,
  getPackClass,
  getPlainPhoneNumber,
  getRemainingDays,
  hasPermission,
  HomeSteps,
  isFutureDate,
  orgNameLimit,
  PAGE_LIMIT,
  // projectFilters,
  selectLoader,
  updateUserDetails
} from '../../utils/Helpers';
import { ProjectListStrings } from './strings/ProjectStrings';
import appToast, { TOAST_TYPE } from '../../utils/AppToast';
import { Link, useNavigate } from 'react-router-dom';
import APIServices from '../../services/APIServices';
import { useStore } from '../../hooks/useStore';
import UpdateProjectForm from './forms/UpdateProjectForm';
import Notifications from '../../components/Notifications';
import { fetchAllTeamMembers, fetchEnumOptions, fetchOrganizations } from '../../utils/fetchData';
import Select, { components } from 'react-select';
import ProfileModalContent from './homeModals/ProfileModalContent';
import UpdateProfileModal from './homeModals/UpdateProfileModal';
import ProjectProgress from '../../components/ProjectProgress';
import SubPlan from 'pages/auth/welcome/SubPlan';
import LeadSubCancel from './subcription/LeadSubCancel';
import SOWContractModal from 'components/SOWContractModal';
import UploadContractOnly from 'components/UploadContractOnly';
import UploadContractContent from 'components/UploadContractContent';
import HomeHeaderContent from 'components/HomeHeaderContent';

const Home = () => {
  const scrollRef = useRef(null);
  const { logout, fetchUserInfo, user, isUser1, userRole, socket, subInfo, isUpdating, isOwner, userShortName } =
    useAuth();
  const [store, setStore] = useStore();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [isUserLoading, setUserLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [isProjectsAvailable, setPojectsAvailable] = useState(null);
  const [projects, setProjects] = useState([]);
  const [formValues, setFormValues] = useState(formFields);
  const [profileUrl, setProfileUrl] = useState('');
  const [runTour, setRunTour] = useState(false);
  const [activeTab, setActiveTab] = useState('pills-profile');
  const [projectId, setProjectId] = useState('');
  const [updatedMilestoneId, setUpdatedMilestoneId] = useState('');
  const [userId, setUserId] = useState('');
  const [isUnread, setUnread] = useState(false);
  const [search, setSearch] = useState('');
  const [currentStatus, setCurrentStatus] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [memberId, setMemberId] = useState('');
  const [totalProjects, setTotalProjects] = useState(0);
  const [statusCounts, setStatusCounts] = useState({});
  const [showOpenProjects, setShowOpenProjects] = useState('');
  const [loadProjects, setLoadProjects] = useState(false);
  const [hasMore, setHasMore] = useState(true); // To track if more projects exists
  const [currentPage, setCurrentPage] = useState(1); // Default to page 1
  const [isUpdatingPlan, setUpdatingPlan] = useState(false); // Default to page 1
  const [isFetchingProjects, setFetchingProjects] = useState(false); // Default to page 1
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [contractFile, setContractFile] = useState(null);
  const [scopeText, setScopeText] = useState('');
  const [contractProjectDetails, setContractProjectDetails] = useState(null);
  const [milestones, setMilestones] = useState([]);
  const [organizationsList, setOrganizationsList] = useState([]);
  const [isInternalProject, setInternalProject] = useState(false);
  // projectFilters
  const [projectFilters, setProjectFilters] = useState([]); // Default to page 1
  const [projectSortOptions, setProjectSortOptions] = useState([]);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);

  const [selectedSortBy, setSelectedSortBy] = useState('');
  const [selectedProjectType, setSelectedProjectType] = useState('');
  const [isVerified, setVerified] = useState({
    isEmailVerified: true,
    isPhoneNumberVerified: true
  });
  const [modals, setModals] = useState({
    profileModal: false,
    updateProfile: false,
    updateProject: false,
    notifications: false
  });

  // Handle tab change
  const handleTabChange = (tabId) => {
    setStore({ tabId: tabId });
    setActiveTab(tabId);
  };

  // functionalities for the paginations of projects while scrolling:
  const scrollLockRef = useRef(false);
  const latestRequestRef = useRef(0);
  const handleScroll = () => {
    const element = scrollRef.current;
    if (element) {
      const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 5;

      if (isAtBottom && !pageLoading && userId && currentPage && hasMore && !loadProjects && !scrollLockRef.current) {
        scrollLockRef.current = true;
        fetchProjects(userId, currentPage + 1, true, setLoadProjects(true));
      }
    }
  };

  const fetchStatusOptions = async () => {
    try {
      const response = await fetchEnumOptions('projectupdate');
      if (response.length > 0) {
        const optionsData = response;
        const formattedStatus = optionsData.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));
        formattedStatus.unshift({
          value: '', // or permission._id if needed
          label: 'All'
        });
        setStatusOptions(formattedStatus);
        let onTimeStatus = formattedStatus.find((x) => x.value == 'ontime');
        // currentStatus(onTimeStatus.id);
      }
    } catch (error) {
      console.error('Error fetching status options:', error);
    } finally {
      // setLoading(false);
    }
  };
  const fetchProjectSortOptions = async () => {
    try {
      const response = await fetchEnumOptions('projectsorting');

      if (response.length > 0) {
        const formattedOptions = response.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));

        setProjectSortOptions(formattedOptions);
        let defaultOption = formattedOptions.find((option) => option.value === 'ALPHABETICAL');
        setSelectedSortBy(defaultOption?.id || '');
      }
    } catch (error) {
      console.error('Error fetching project sort options:', error);
    }
  };

  const fetchProjectTypeOptions = async () => {
    try {
      const response = await fetchEnumOptions('projecttypefilter');

      if (response.length > 0) {
        const formattedOptions = response.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));

        setProjectTypeOptions(formattedOptions);
        let defaultOption = formattedOptions.find((option) => option.value === 'ALL');

        setSelectedProjectType(defaultOption?.id || '');
      }
    } catch (error) {
      console.error('Error fetching project type options:', error);
    }
  };
  const fetchProjectStatusOptions = async () => {
    try {
      const response = await fetchEnumOptions('project_status');
      if (response.length > 0) {
        const optionsData = response;
        const formattedStatus = optionsData.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));
        setProjectFilters(formattedStatus);
        let defaultOption = formattedStatus.find((option) => option.value === 'open');
        setShowOpenProjects(defaultOption?.id || '');
      }
    } catch (error) {
      console.error('Error fetching status options:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAvailability = async (userId) => {
    try {
      const response = await APIServices.get(`/project/user/status/count/${userId}`);
      setPojectsAvailable((response?.totalProjects || 0) > 0);
    } catch (error) {
      console.error('Error checking project availability:', error);
      setPojectsAvailable(true);
    }
  };

  // Fetch details of the user.
  const fetchUserDetails = async (user) => {
    const token = getCookies('authToken');

    if (!token) return; // Early return if no token

    try {
      setPageLoading(true);
      setUserLoading(true);
      const userDetails = await fetchUserInfo();

      // setDataLoading(true);
      if (userDetails) {
        if (!userDetails.companyId) {
          // navigate('/login');
          logout();
        }
        setUserLoading(false);
        const {
          email,
          countryDialCode,
          phoneNumber,
          fullName,
          countryCode,
          profilePic,
          companyId,
          isTotorialVisited,
          isEmailVerified,
          isPhoneNumberVerified
        } = userDetails;

        // Update form values and verification status in a single state update
        setFormValues((prevValues) => ({
          ...prevValues,
          email,
          countryDialCode,
          phoneNumber: getformattedPhoneNumber(phoneNumber),
          fullName,
          countryCode,
          profilePic,
          companyName: companyId?.name,
          isTotorialVisited
        }));

        setVerified({
          isEmailVerified,
          isPhoneNumberVerified
        });

        // Trigger the tour based on tutorial visited status
        setRunTour(!isTotorialVisited);
        setUserId(userDetails._id);
        fetchProjectAvailability(userDetails._id);
        fetchAllTeamMembers(setTeamMembers);
        fetchStatusOptions();
        fetchProjectStatusOptions();
        fetchProjectSortOptions();
        fetchProjectTypeOptions();
        // fetchProjects(userDetails._id, currentPage);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      if (!userId || (subInfo && !subInfo?.isActive && isOwner)) {
        setPageLoading(false);
        // setDataLoading(false);
        setLoadProjects(false);
      }
    }
  };

  const fetchProjects = async (userId, page = 0, isSocket = false, callback) => {
    if (!userId || (subInfo && !subInfo?.isActive && isOwner) || !selectedSortBy || !selectedProjectType || !showOpenProjects) {
      return;
    }
    if (callback) {
      callback();
    }
    if (!isSocket) {
      setPageLoading(true);
    }
    setFetchingProjects(true);
    const requestId = ++latestRequestRef.current;
    try {
      const response = await APIServices.get(
        `/project/user/${userId}?search=${search}&page=${page}&limit=${30}&status=${currentStatus}&teamUserId=${memberId}&projectStatus=${showOpenProjects}&sortby=${selectedSortBy}&type=${selectedProjectType}`
      );
      if (requestId !== latestRequestRef.current) return; // a newer request superseded this one
      if (response.projects) {
        if (page == 1) {
          setProjects(response.projects);
          setHasMore(true);
        } else {
          setProjects((prev) => [...prev, ...response.projects]);
          // console.log(response.projects);

          const scrollContainer = scrollRef.current;
          const previousScrollHeight = scrollContainer?.scrollHeight;
          const previousScrollTop = scrollContainer.scrollTop;
          // setTimeout(() => {
          const newScrollHeight = scrollContainer?.scrollHeight;
          // Adjust scrollTop to maintain the same view position
          scrollContainer.scrollTop = previousScrollTop + (newScrollHeight - previousScrollHeight - 20);
          // }, 0);
          setHasMore(response.projects.length === 30);
        }
        setStatusCounts(response?.statusCounts);
        setTotalProjects(response?.totalProjects);
        if (response.projects.length > 0) {
          // setPojectsAvailable(true);
        }

        setCurrentPage(page);
      } else if (response?.data?.message) {
        appToast(response?.data?.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
      if (requestId === latestRequestRef.current) {
        appToast('Failed to load projects. Please try again.', TOAST_TYPE.ERROR);
      }
    } finally {
      scrollLockRef.current = false;
      if (requestId === latestRequestRef.current) {
        setPageLoading(false);
        setDataLoading(false);
        setLoadProjects(false);
        setFetchingProjects(false);
      }
    }
  };

  useEffect(() => {
    if (!userId) return;

    const handler = setTimeout(() => {
      fetchProjects(userId, 1);
    }, 300);

    // Cleanup function to clear the timeout if dependencies change before delay
    return () => clearTimeout(handler);
  }, [search, currentStatus, memberId, showOpenProjects, selectedSortBy, selectedProjectType]);

  useEffect(() => {
    if (!userId) return;

    fetchProjects(userId, 1);
  }, [subInfo?.isActive]);

  useEffect(() => {
    fetchUserDetails();
    clearLocalStorage();
    fetchOrganizations().then((orgs) => setOrganizationsList(orgs));
    setActiveTab(store.tabId || 'pills-profile');
    let isUpdatingPlan = localStorage.getItem('isUpdatingPlan');
    if (isOwner) {
      if (isUpdatingPlan === 'true') {
        setUpdatingPlan(true);

        setTimeout(() => {
          setUpdatingPlan(false);
          localStorage.setItem('isUpdatingPlan', false);
        }, process.env.REACT_APP_SUBSCRIPTION_SLEEP_TIME);
      }
    } else {
      localStorage.setItem('isUpdatingPlan', false);
    }
  }, []);

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  const updateCloseModal = (modalname) => {
    if (modalname == 'updateProject') {
      setCurrentPage(1);
    }
    toggleModal(modalname, false);
    fetchProjects(userId, currentPage);
  };

  const handleKanbanIconClick = (isCalenderView = false) => {
    navigate('/project-boards', {
      state: {
        isCalenderView
      }
    });
  }; // This goes back to the previous page
  const updateProjects = (apiProjects, socketProject) => {
    return apiProjects.map((project) => (project._id === socketProject._id ? socketProject : project));
  };

  const isEditor = (project) => {
    let isPermission = project?.projectTeam?.myTeam?.find((member) => member.userId._id === userId)?.permission;
    // console.log(isPermission.name);
    if (isPermission?.name === 'View') {
      return false;
    }
    return true;
  };

  useEffect(() => {
    // Listen for 'projectActivityUpdate' event
    if (socket) {
      const handle_Notification = (Notification) => {
        // scrollToBottom();
        setUnread(true);
        // console.log('Notification', Notification);
      };
      const handle_ProjectCreated = (Notification) => {
        if (!isFetchingProjects) {
          setHasMore(true);
          fetchProjects(userId, currentPage, true);
        }
        // console.log('ProjectCreated', Notification);
      };
      const handle_ProjectUpdated = (updatedProject) => {
        // setHasMore(true);
        // fetchProjects(userId, currentPage, true);
        if ((subInfo?.isActive && isUser1) || !isUser1) {
          setProjects((prevProjects) => updateProjects(prevProjects, updatedProject));
        }
        // console.log('ProjectUpdated', updatedProject);
      };
      const handle_UserSubscriptionUpdated = (activity) => {
        if (!isUpdating) {
          fetchUserInfo();
          setUpdatingPlan(false);
          localStorage.setItem('isUpdatingPlan', false);
        }
        // console.log('UserSubscriptionUpdated', activity);
      };
      const handle_SubscriptionPurchaseStarted = (activity) => {
        // if (!isUpdatingPlan) {
        setUpdatingPlan(true);
        localStorage.setItem('isUpdatingPlan', true);
        // }
        setTimeout(() => {
          setUpdatingPlan(false);
          localStorage.setItem('isUpdatingPlan', false);
        }, process.env.REACT_APP_SUBSCRIPTION_SLEEP_TIME);
        console.log('SUBSCRIPTION_SLEEP_TIME', process.env.REACT_APP_SUBSCRIPTION_SLEEP_TIME);

        console.log('UserSubscriptionUpdated', activity);
      };
      socket?.on('Notification', handle_Notification);
      socket?.on('ProjectCreated', handle_ProjectCreated);
      socket?.on('ProjectUpdated', handle_ProjectUpdated);
      socket?.on('UserSubscriptionUpdated', handle_UserSubscriptionUpdated);
      socket?.on('SubscriptionPurchaseStarted', handle_SubscriptionPurchaseStarted);
      return () => {
        socket?.off('Notification', handle_Notification);
        socket?.off('ProjectCreated', handle_ProjectCreated);
        socket?.off('ProjectUpdated', handle_ProjectUpdated);
        socket?.off('UserSubscriptionUpdated', handle_UserSubscriptionUpdated);
        socket?.off('SubscriptionPurchaseStarted', handle_SubscriptionPurchaseStarted);
      };
    }
  }, [socket]);

  const HeaderContent = (
    <HomeHeaderContent
      isProjectsAvailable={isProjectsAvailable}
      subInfo={subInfo}
      isUser1={isUser1}
      userRole={userRole}
      isOwner={isOwner}
      user={user}
      totalProjects={totalProjects}
      statusCounts={statusCounts}
      isUnread={isUnread}
      isUpdatingPlan={isUpdatingPlan}
      userShortName={userShortName}
      onStatusClick={setCurrentStatus}
      onProfileClick={() => toggleModal('profileModal', true)}
      onNotificationClick={() => {
        toggleModal('notifications', true);
        setUnread(false);
      }}
      onKanbanClick={handleKanbanIconClick}
    />
  );

  // Handle events like close or skip
  const handleJoyrideCallback = (data) => {
    const { action } = data;

    if (action == 'reset' || action === 'close') {
      setRunTour(false);
      let plainNumber = getPlainPhoneNumber(formValues.phoneNumber);

      const updatedFormValues = {
        ...formValues,
        isTotorialVisited: true,
        phoneNumber: plainNumber
      };

      setFormValues(updatedFormValues);
      let isUpdated = updateUserDetails(updatedFormValues, setError, setLoading, false);
    }
    // console.log(data); // Log the Joyride event for debugging
  };

  const handleUpdateProject = (project) => {
    if (project?.isSubscriptionActive) {
      navigate(`/project-board/project/${project._id}`, {
        state: {
          // Tell ProjectBoard to open the Overview tab by default.
          boardViewType: 'overview',
          isProjectRelatedBoard: true,
          projectId: project._id,
          projectDetails: project,
          isFromHome: true
        }
      });
    } else {
      navigate('/project-subscription-unavailable', {
        state: { projectDetails: project }
      });
    }
  };
  const handleUpdateMilestone = (project) => {
    let projectId = project._id;
    let isFutureProject = isFutureDate(project.startDate || new Date());
    if (isFutureProject) {
      appToast('Cannot update the project with a future start date', TOAST_TYPE.ERROR);
      return;
    }
    toggleModal('updateProject', true);
    setProjectId(projectId);
    console.log(projectId);
  };

  const CustomMenuList = ({ children, ...props }) => {
    return (
      <components.MenuList {...props}>
        <div className="select-menu-title">{props.selectProps.menuTitle}</div>
        {children}
      </components.MenuList>
    );
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (isUserLoading) {
    return <div className="nodata-loader">{selectLoader(70)}</div>;
  }

  return (
    <div className="wrapper">
      <Header content={HeaderContent} />
      <div className="main-content">
        {dataLoading || isProjectsAvailable === null ? (
          <div className="nodata-loader">{selectLoader(75)} </div>
        ) : isUser1 && !isOwner && !subInfo?.isActive ? (
          <LeadSubCancel />
        ) : !subInfo?.isActive && isOwner ? (
          <SubPlan isHome={true} />
        ) : isProjectsAvailable ? (
          <section className="dashboard-sec home-dashboard-sec">
            <Joyride
              callback={handleJoyrideCallback}
              steps={HomeSteps}
              continuous={true}
              showSkipButton={false}
              hideCloseButton={true}
              showProgress={true}
              run={runTour}
              locale={{
                back: ProjectListStrings.prevButton,
                close: ProjectListStrings.closeButton,
                last: ProjectListStrings.lastButton,
                next: ProjectListStrings.nextButton,
                skip: ProjectListStrings.skipButton
              }}
            />
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card-top-sec">
                    <div className="top-field-cover">
                      <div className="form-group search-box">
                        <input
                          maxLength={orgNameLimit}
                          type="search"
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          id="search-box-tour"
                          className="form-control search-box-control"
                          placeholder={ProjectListStrings.searchPlaceholder}
                        />
                        <img src={searchIcon} className="search-icon" />
                      </div>

                      <div className="form-group select-project form-group-select-icon">
                        <Select
                          className={`form-control select2 `}
                          options={teamMembers || []}
                          value={teamMembers.find((option) => option.value === memberId)}
                          onChange={(option) => setMemberId(option?.value)}
                          placeholder="Members"
                          // isClearable
                          isLoading={loading}
                          menuTitle="Members"
                          components={{
                            MenuList: CustomMenuList
                          }}
                        />
                      </div>
                      <div className="form-group select-status form-group-select-icon">
                        <Select
                          className={`form-control select2 `}
                          options={projectTypeOptions || []}
                          value={projectTypeOptions.find((option) => option.id === selectedProjectType)}
                          onChange={(option) => setSelectedProjectType(option?.id)}
                          placeholder="Type"
                          isLoading={loading}
                          menuTitle="Type"
                          components={{
                            MenuList: CustomMenuList
                          }}
                        />
                      </div>
                      <div className="form-group select-status form-group-select-icon">
                        <Select
                          className={`form-control select2 `}
                          options={statusOptions || []}
                          value={statusOptions.find((option) => option.value === currentStatus)}
                          onChange={(option) => setCurrentStatus(option?.value)}
                          placeholder="Status"
                          // isClearable
                          isLoading={loading}
                          menuTitle="Update Status"
                          components={{
                            MenuList: CustomMenuList
                          }}
                        />
                      </div>
                      <div className="form-group select-status form-group-select-icon">
                        <Select
                          className={`form-control select2 `}
                          options={projectFilters || []}
                          value={projectFilters.find((option) => option.id === showOpenProjects)}
                          onChange={(option) => setShowOpenProjects(option?.id)}
                          placeholder="Project Status"
                          // isClearable
                          isLoading={loading}
                          menuTitle="Project Status"
                          components={{
                            MenuList: CustomMenuList
                          }}
                        />
                      </div>
                      <div className="form-group select-status form-group-select-icon">
                        <Select
                          className={`form-control select2 `}
                          options={projectSortOptions || []}
                          value={projectSortOptions.find((option) => option.id === selectedSortBy)}
                          onChange={(option) => setSelectedSortBy(option?.id)}
                          placeholder="Sort By"
                          isLoading={loading}
                          menuTitle="Sort By"
                          components={{
                            MenuList: CustomMenuList
                          }}
                        />
                      </div>
                    </div>

                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab == 'pills-home' ? 'active' : ''}`}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="false"
                          onClick={() => handleTabChange('pills-home')}>
                          <img
                            src={activeTab == 'pills-home' ? listWhiteIcon : listIcon}
                            className="list-icon"
                            alt={ProjectListStrings.homeTabAlt}
                          />
                        </button>
                      </li>

                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab == 'pills-profile' ? 'active' : ''}`}
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="true"
                          onClick={() => handleTabChange('pills-profile')}>
                          <img
                            src={activeTab == 'pills-profile' ? gridWhiteIcon : gridIcon}
                            className="home-icon"
                            alt={ProjectListStrings.profileTabAlt}
                          />
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className={`tab-pane fade  ${activeTab == 'pills-home' ? 'show active' : ''}`}
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="project-list">
                            <div
                              className="table-responsive"
                              onScroll={handleScroll}
                              ref={scrollRef}
                              style={{ maxHeight: '82vh', overflowY: 'auto' }}>
                              <table className="table">
                                <tbody>
                                  {pageLoading ? (
                                    <div className="nodata-loader">{selectLoader(70)}</div>
                                  ) : (
                                    projects.map((project) => (
                                      <tr
                                        className="bottom-spacing cursor_pointer"
                                        key={project._id}
                                        onClick={() => handleUpdateProject(project)}>
                                        <td style={{ width: '450px' }}>
                                          <p>{project?.projectName}</p>
                                          {project?.latestUpdate?.[0]?.updateStatus?.value == 'late' ? (
                                            <p className="red-text">#Late</p>
                                          ) : project?.latestUpdate?.[0]?.updateStatus?.value == 'early' ? (
                                            <p className="blue-text">#Early</p>
                                          ) : (
                                            <p className="green-text">#On-time</p>
                                          )}
                                        </td>
                                        <td style={{ minWidth: '350px' }}>
                                          <div className="tableList-processBg">
                                            <ProjectProgress project={project} />
                                          </div>
                                        </td>

                                        <td style={{ width: '13%' }}>
                                          {/* {hasPermission(userRole, 'update_projects') && isEditor(project) && (
                                            <button
                                              className="updated-btn"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleUpdateMilestone(project);
                                              }}>
                                              Update
                                            </button>
                                          )} */}
                                          <div className="d-flex align-items-center justify-content-end">
                                            {project.updateCount > 0 && (
                                              <>
                                                <div className="me-2">
                                                  <img src={chatBoxes} style={{ maxWidth: 'none' }} />
                                                </div>
                                                <h4 className="mb-0">{project.updateCount}</h4>{' '}
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                  {loadProjects && (
                                    <tr>
                                      <td colSpan="3">
                                        <div className="text-center">{selectLoader(40)}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      {projects.length == 0 && (
                        <div className="row align-items-center">
                          <div className="col-lg-12">
                            <div className="blankList-box-cover">
                              <div className="blankList-box">
                                <img className="akarFile" src={akarFile2} />

                                <h2>We couldn’t find any data to display.</h2>

                                <p>Try updating your search criteria.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      onScroll={handleScroll}
                      ref={scrollRef}
                      className={`tab-pane fade  ${activeTab == 'pills-profile' ? 'show active' : ''}`}
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab">
                      <div className="row">
                        {pageLoading ? (
                          <div className="nodata-loader">{selectLoader(70)} </div>
                        ) : (
                          projects.map((project) => {
                            const latestUpdate = project?.latestUpdate?.[0] || {};
                            const status = latestUpdate?.updateStatus?.value || 'ontime';

                            const isLate = status === 'late';
                            const isEarly = status === 'early';

                            const progress = project?.progress?.toFixed(0) || 0;

                            const deliveryDate = isLate || isEarly ? project?.updatedEndDate : project?.endDate;

                            const remainingDays = getRemainingDays(deliveryDate);

                            const statusLabel = project?.isDraft
                              ? 'Draft'
                              : isLate
                                ? 'Late'
                                : isEarly
                                  ? 'Early'
                                  : 'On-time';

                            const statusColor = isLate ? '#E24A4A' : isEarly ? '#195FA4' : '#639922';

                            const daysText = isEarly
                              ? `${latestUpdate?.daysEarly || 0} days`
                              : isLate
                                ? `${latestUpdate?.daysLate || 0} days`
                                : '0 days';

                            const daysLabel = isEarly ? 'Ahead' : isLate ? 'Behind' : 'On track';

                            return (
                              <div className="col-lg-4 col-md-6 mb-4" key={project._id}>
                                <div
                                  className="card-wrapper-cover cursor_pointer"
                                  onClick={() => handleUpdateProject(project)}>
                                  <div className="option-card home-card">
                                    {/* TOP */}
                                    <div className="card-top">
                                      <div className="lefttop-card">
                                        <h2 className="title">{project.projectName}</h2>
                                        <p className="subtitle">
                                          {isUser1
                                            ? project?.organizationId?.name || project?.createdBy?.companyId?.name
                                            : project?.createdBy?.companyId?.name}
                                        </p>
                                      </div>

                                      <div className="top-actions">
                                        <button className={`status-btn ${project?.isDraft ? 'draft' : status}`}>
                                          {statusLabel}
                                        </button>
                                      </div>
                                    </div>
                                    {/* MIDDLE */}
                                    <div className="card-middle">
                                      <span className="date">{formatDate(project?.startDate || new Date())}</span>
                                      <span className="percent">{progress}%</span>
                                    </div>
                                    {/* PROGRESS BAR */}
                                    <div className="progress-bar">
                                      <div
                                        className="progress-fill"
                                        style={{
                                          width: `${progress}%`,
                                          backgroundColor: statusColor
                                        }}
                                      />
                                    </div>
                                    {/* INFO GRID */}
                                    <div className="info-grid">
                                      <div className="info-box">
                                        <h3 className="remaining-text">
                                          {remainingDays > 0 ? `${remainingDays} days` : '0 days'}
                                        </h3>
                                        <p>Remaining</p>
                                      </div>

                                      <div className="info-box">
                                        <h3 className={`highlight ${status}`}>
                                          {formatDate(deliveryDate || new Date())}
                                        </h3>
                                        <p>{isLate || isEarly ? 'Est. delivery' : 'Delivery date'}</p>
                                      </div>

                                      {(isLate || isEarly) && (
                                        <div className="info-box">
                                          <h3 className={`highlight ${status}`}>{daysText}</h3>
                                          <p>{daysLabel}</p>
                                        </div>
                                      )}
                                    </div>
                                    {/* FOOTER */}
                                    <div className="card-footer">
                                      {project?.isSubscriptionActive === false ? (
                                        <span className="progress-delaytext project-expired">
                                          Subscription Expired.
                                        </span>
                                      ) : project?.averageRating ? (
                                        <div className="ratings-container">
                                          {[...Array(5)].map((_, index) => (
                                            <div key={index} className="rating-card">
                                              <img
                                                src={index < (project?.averageRating || 0) ? starSvg : starOpSvg}
                                                alt="Star"
                                              />
                                            </div>
                                          ))}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      <span className="modify-footer-text">
                                        {project?.latestUpdate?.[0]?.createdBy ? (
                                          <>
                                            Modified by {project.latestUpdate[0].createdBy.fullName},{' '}
                                            {formatDate(project.createdBy.updatedAt || new Date())}
                                          </>
                                        ) : (
                                          <>
                                            Created by {project.createdBy.fullName},{' '}
                                            {formatDate(project.createdDate || new Date())}
                                          </>
                                        )}
                                      </span>
                                      {/* {hasPermission(userRole, 'update_projects') && isEditor(project) && !project?.isDraft &&(
                                        <span
                                          className="update-text-footer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleUpdateMilestone(project);
                                          }}>
                                          Update <div><img src={rightArrowBlue} className='right-update-icon' alt="update" /><img src={rightArrowBlue} className='right-update-icon' alt="update" /></div>
                                        </span>
                                      )} */}
                                    </div>

                                    {/* OPTIONAL: Subscription warning */}
                                    {project?.isSubscriptionActive === false && (
                                      <span className="progress-delaytext project-expired pt-2">
                                        Project owner's subscription has expired.
                                      </span>
                                    )}
                                    {/* OPTIONAL: Updates count */}
                                    {/* {project.updateCount > 0 && (
                                      <div className="comment-chat mt-2">
                                        <img src={chatBoxes} alt="Chat Icon" />
                                        <h5 className="updates-card-sec">{project.updateCount} Updates</h5>
                                      </div>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                        {loadProjects && <div>{selectLoader(70)} </div>}
                      </div>
                      {projects.length == 0 && (
                        <div className="row align-items-center">
                          <div className="col-lg-12">
                            <div className="blankList-box-cover">
                              <div className="blankList-box">
                                <img className="akarFile" src={akarFile2} />

                                <h2>We couldn’t find any data to display.</h2>

                                <p>Try updating your search criteria.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {hasPermission(userRole, 'modify_team') && (
              <ActionMenu
                extraClass="options-list-comman"
                links={[
                  hasPermission(userRole, 'create_projects') && {
                    text: ProjectListStrings.createProjectText,
                    className: 'create_project',
                    linkto: '/create-project'
                  },

                  hasPermission(userRole, 'modify_team') && {
                    text: ProjectListStrings.createProjectWithContract,
                    className: 'create_project',
                    onClick: () => setShowUploadModal(true)
                    // linkto: '/create-project/true'
                  }, // this should open the upload contract modal
                  hasPermission(userRole, 'modify_team') && {
                    text: ProjectListStrings.createTeamText,
                    className: 'create_team',
                    linkto: '/myteam'
                  }
                ]}
                buttonIcon="fas fa-plus"
                buttonStyles={{ backgroundColor: 'blue', color: 'white' }}
                showItem={!formValues?.isTotorialVisited}
              />
            )}
          </section>
        ) : (
          <section className="blank-sec dashboard-sec home-dashboard-sec">
            <div className="container">
              <div className="row align-items-start">
                <div className="col-lg-12">
                  <div className="blankList-box-cover">
                    <div className="blankList-box">
                      <img className="akarFile" src={akarFile} />
                      <h2>{ProjectListStrings.noProjectsTitle}</h2>
                      {hasPermission(userRole, 'update_projects') && <p>{ProjectListStrings.noProjectsDescription}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {hasPermission(userRole, 'modify_team') && (
              <ActionMenu
                extraClass="options-list-comman"
                links={[
                  hasPermission(userRole, 'create_projects') && {
                    text: ProjectListStrings.createProjectText,
                    className: 'create_project',
                    linkto: '/create-project'
                  },
                  hasPermission(userRole, 'modify_team') && {
                    text: ProjectListStrings.createProjectWithContract,
                    className: 'create_team',
                    linkto: '/myteam'
                  },
                  hasPermission(userRole, 'modify_team') && {
                    text: ProjectListStrings.createTeamText,
                    className: 'create_team',
                    linkto: '/myteam'
                  }

                  // hasPermission(userRole, "create_projects") && {
                  //   text: ProjectListStrings.createTaskText,
                  //   className: "create_task",
                  //   linkto: "/create-project",
                  // },
                ]}
                buttonIcon="fas fa-plus"
                buttonStyles={{ backgroundColor: 'blue', color: 'white' }}
                showItem={false}
              />
            )}
          </section>
        )}
        {/* Modal Component */}
        <SidebarModal show={modals.profileModal} onHide={() => toggleModal('profileModal', false)}>
          <ProfileModalContent
            profileUrl={profileUrl}
            formValues={formValues}
            isVerified={isVerified}
            toggleModal={toggleModal}
            userRole={userRole}
            hasPermission={hasPermission}
            logout={logout}
            subInfo={subInfo}
            templateBackUrl={`/`}
            setError={setError}
            setLoading={setLoading}
          />
        </SidebarModal>

        {/* Modal Component */}
        <SidebarModal
          extraClass={'edit-profile-modal notification-modal'}
          show={modals.notifications}
          onHide={() => toggleModal('notifications', false)}
          headerTitle={'Happy Ending Project'}>
          <Notifications closeModal={() => toggleModal('notifications', false)} />
        </SidebarModal>

        <SidebarModal
          extraClass={'edit-profile-modal'}
          show={modals.updateProfile}
          onHide={() => toggleModal('updateProfile', false)}
          headerTitle={ProjectListStrings.editProfileHeader}>
          <UpdateProfileModal
            profileUrl={profileUrl}
            formValues={formValues}
            setError={setError}
            isVerified={isVerified}
            toggleModal={toggleModal}
            setFormValues={setFormValues}
            selectLoader={selectLoader}
            setProfileUrl={setProfileUrl}
          />
        </SidebarModal>
        <SidebarModal
          extraClass={'edit-profile-modal'}
          show={modals.updateProject}
          onHide={() => toggleModal('updateProject', false)}
          headerTitle={'Update Project'}>
          <UpdateProjectForm projectId={projectId} closeModal={() => updateCloseModal('updateProject')} />
        </SidebarModal>

        <SOWContractModal
          show={showUploadModal}
          onHide={() => {
            setShowUploadModal(false);
            setScopeText('');
            setMilestones([]);
            setContractProjectDetails(null);
          }}
          title="Upload Contract">
          <UploadContractOnly
            onUploadSuccess={(file, data) => {
              setContractFile(file);
              setScopeText(data.scope);
              setMilestones(data.milestones);
              setContractProjectDetails(data.project);
              setShowUploadModal(false);
              setShowPreviewModal(true); // 👈 open preview
            }}
          />
        </SOWContractModal>
        <SOWContractModal
          show={showPreviewModal}
          onHide={() => {
            setShowPreviewModal(false);
            setScopeText('');
            setMilestones([]);
            setContractProjectDetails(null);
          }}
          title="Preview Contract">
          <UploadContractContent
            showDetails={true}
            initialFile={contractFile}
            initialScope={scopeText}
            initialMilestones={milestones}
            initialProjectData={contractProjectDetails}
            organizationsList={organizationsList}
            setScopeText={setScopeText}
            setMilestonesData={setMilestones}
            setProjectDetailsData={setContractProjectDetails}
            setInternalProject={setInternalProject}
            onConfirm={(file) => {
              // 👇 redirect to create project with prefilled data
              navigate('/create-with-contract', {
                state: {
                  contractPrefillDetails: {
                    contractFile: file,
                    scope: scopeText,
                    milestones,
                    projectDetails: contractProjectDetails,
                    isInternalProjectData: isInternalProject
                  }
                }
              });

              setShowPreviewModal(false);
            }}
          />
        </SOWContractModal>
      </div>
    </div>
  );
};

export default Home;
